import PropTypes from 'prop-types';
import useRetainScrollPosition from 'hooks/useRetainScrollPosition';

const ScrollPositionManager = ({ location }) => {
  // Use the hook inside this component, which will be rendered inside the Redux Provider
  useRetainScrollPosition(location);

  // This component doesn't render anything
  return null;
};

ScrollPositionManager.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default ScrollPositionManager;
